import { render, staticRenderFns } from "./ParametrizacionDias.vue?vue&type=template&id=0f24fc98&scoped=true"
import script from "./ParametrizacionDias.vue?vue&type=script&lang=js"
export * from "./ParametrizacionDias.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacionDias.vue?vue&type=style&index=0&id=0f24fc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24fc98",
  null
  
)

export default component.exports